class QuickAdd extends HTMLElement {
    constructor() {
        super();

        this.handle = this.dataset.handle;
        this.init_btn = this.querySelector('.js-quick-add-on');
        this.selection_container = this.querySelector('.pr-option-container')
        this.variant_options_element = this.querySelectorAll('[data-quick-add-options]')
        this.add_to_cart_btn = this.querySelector('.quick-add-cta-btn');
        this.close_btn = this.querySelector('.js-close-option-popup')


        this.init_btn.addEventListener('click', () => {
            this.selection_container.style.display = '';
            this.init_btn.style.display = 'none';
            this.getProductData(this.handle);

            //Get rid of slider translation
            if(window.innerWidth <= 768) {
                var slider_container = this.slider_container || this.closest('.flickity-slider')

                if(slider_container) {
                    this.selection_container.classList.add('is-slider')
                    // this.slider_container = slider_container;
                    // if(slider_container.style.transform) {
                    //     this.slider_container_transform = slider_container.style.transform
                    //     slider_container.style.transform = '';
                    // }
                }
            }
        })
        this.add_to_cart_btn.addEventListener('click', this.handleAddToCart.bind(this))
        this.close_btn.addEventListener('click', this.close.bind(this))
        this._loadSelectionBtnEvent();
        this.clickOutside();
        this.getSelectedOptions();
    }
    handleAddToCart() {
        const cart_btn = this.add_to_cart_btn;

        if(!cart_btn.classList.contains('btn-ready')) {
            this.showMissingSelection();
            return;
        }

        if(cart_btn.classList.contains('item-added')) {
            this.close()
            return;
        }
        const selected_variant = this.getSelectedVariant();
        
        if(selected_variant) {
            this.addToBag(selected_variant)
        }
    }
    addToBag(variant) {
        if(!variant) return;

        this.add_to_cart_btn.classList.add('init-adding-to-cart')
        this.add_to_cart_btn.classList.remove('btn-ready')
        this.add_to_cart_btn.querySelector('.btn-label').innerHTML = '';
        this.add_to_cart_btn.querySelector('.btn-label').innerHTML = this.loaderTemplate()

        let formData = {
            'items': [
                {
                    'id': parseInt(variant.id),
                    'quantity': 1
                }
            ]
        };
        var _this = this;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            _this.add_to_cart_btn.classList.remove('init-adding-to-cart')
            if(data.status === 422) {
                alert(data.description)
                _this.add_to_cart_btn.querySelector('.btn-label').innerHTML = '';
                _this.add_to_cart_btn.querySelector('.btn-label').textContent = 'Select a size'
                return;
            }
            console.log(data)


          data.items.forEach(product => {
            gtag("event", "add_to_cart", {
              currency: "PHP",
              items: [
                {
                  item_id: product.product_id.toString(),
                  item_name: product.title,
                  currency: "PHP",
                  item_brand: product.vendor,
                  item_category: product.product_type,
                  item_variant: product.variant_title,
                  price: (parseInt(product.price) / 100).toFixed(2),
                  quantity: product.quantity
                }
              ]
            });
  
            
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
              event: 'addToCart',
              ecommerce: {
                currencyCode: "PHP",
                add: {
                  products: [{
                    name: product.title,
                    id: product.product_id.toString(),
                    price: (parseInt(product.price) / 100).toFixed(2),
                    brand: product.vendor,
                    category: product.product_type,
                    variant: product.variant_title,
                    quantity: product.quantity
                   }]
                }
              }
            });
          })
            _this.add_to_cart_btn.classList.add('item-added')
            _this.add_to_cart_btn.querySelector('.btn-label').innerHTML = '';
            _this.add_to_cart_btn.querySelector('.btn-label').textContent = 'Added to bag'
            Shopify.theme.jsAjaxCart.showDrawer();
            Shopify.theme.jsAjaxCart.updateView();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
    loaderTemplate() {
        const loader = `
        <div class="loading-dots">
            <div class="loading-dots--dot"></div>
            <div class="loading-dots--dot"></div>
            <div class="loading-dots--dot"></div>
        </div>
        `
        return loader;
    }
    getSelectedVariant() {
        const selected = this.selected_options;

        const selected_variant = this.data.variants.find(function(variant) {
			return selected.every(function(values) {
                var title_found = variant.title.split(' / ')[values.index] === values.value;
                return title_found;
			})
		})
        return selected_variant;
    }
    showMissingSelection() {
        const unselect_option = [];

        var missingSelectionTpl = `<div class="quick-add-warning">Please select a <strong>{{options}}</strong> before adding to bag.</div>`;

        this.variant_options_element.forEach(option => {
            const selected_value = option.querySelector('.js-select-value.selected')
            if(!selected_value) unselect_option.push(option.dataset.option)
        })

        if(unselect_option.length > 0) {
            missingSelectionTpl = missingSelectionTpl.replace(/{{options}}/g, unselect_option.join(', '))
            
            if(this.querySelector('.quick-add-warning')) this.querySelector('quick-add-warning').remove();

            this.querySelector('.qa-warning-container').innerHTML = new DOMParser().parseFromString(missingSelectionTpl, 'text/html').querySelector('body').innerHTML
        }
    }
    _loadSelectionBtnEvent() {
        this.measurement_selection_btns = this.querySelectorAll('.js-select-value');
        this.measurement_selection_btns.forEach(btn => {
            btn.addEventListener('click', () => {
                if(btn.classList.contains('disabled')) return;
                this.toggleSelectedClass(btn)
                this.toggleAvailableSelections(btn)
            });
        })
    }
    getSelectedOptions() {
        const selected_option_btns = this.querySelectorAll('.option-values .js-select-value.selected');
        const selected_options = [];

        selected_option_btns.forEach(selected => {
            const input = selected.querySelector('.option-input-value')
            const value = input.value
            const index = parseInt(input.dataset.valueIndex)

            selected_options.push({
                value,
                index
            })
        })

        this.selected_options = selected_options

        return selected_options;
    }
    toggleAvailableSelections(btn) {
        const option_els = this.variant_options_element;
        const input_value = btn.querySelector('.option-input-value');
        const current_selected_value = input_value.value;
        const current_selected_option_index = parseInt(input_value.dataset.valueIndex);
        const variants = this.data.variants.filter(variant => variant.options[current_selected_option_index] === current_selected_value);
        
        const selected_options = this.getSelectedOptions();
        this.add_to_cart_btn.classList.remove('item-added')

        if(option_els.length === selected_options.length) {
            this.add_to_cart_btn.classList.add('btn-ready')
			this.add_to_cart_btn.querySelector('.btn-label').textContent = 'Add to bag';
            if(this.querySelector('.quick-add-warning')) this.querySelector('.quick-add-warning').remove();
        }else {
            this.add_to_cart_btn.classList.remove('btn-ready')
			this.add_to_cart_btn.querySelector('.btn-label').textContent = 'Select a size';
        }

        option_els.forEach(option => {
            const index = parseInt(option.dataset.index);
            if(index !== current_selected_option_index) {
                const option_btns = option.querySelectorAll('.option-values .js-select-value');

                option_btns.forEach(opt_btn => {
                    const opt_btn_input = opt_btn.querySelector('.option-input-value');
                    const opt_btn_value = opt_btn_input.value;
                    const available_variants = variants.filter(variant => {
                        const variant_options = variant.title.split(' / ');
                        return variant_options[index] === opt_btn_value && variant.available;
                    });

                    if(available_variants.length > 0) {
                        opt_btn.classList.remove('disabled')
                    }else {
                        opt_btn.classList.remove('selected')
                        opt_btn.classList.add('disabled')
                    }
                })
            }
        })
    }
    toggleSelectedClass(btn) {
        const btns = btn.closest('.option-values').querySelectorAll('.js-select-value');
        btn.classList.toggle('selected');
        btns.forEach(button => {
            if(button !== btn) {
                button.classList.remove('selected');
            }
        })
    }
    async getProductData(handle) {
        const url = `/products/${handle}.js`

        const data = await fetch(url).then(response => response.json()).then(data => data);

        this.selection_container.classList.remove('on-loading');

        this.data = data;
    }
    clickOutside() {
        document.addEventListener('click', (e) => {
            if(!this.contains(e.target)) {
                this.close();
            }
        })
    }
    close() {
        this.init_btn.style.display = '';
        this.selection_container.style.display = 'none';
        this.selection_container.classList.remove('is-slider')
        
        // if(window.innerWidth <= 768) {
        //     if(this.slider_container && this.slider_container_transform) {
        //         this.slider_container.style.transform = this.slider_container_transform;
        //         this.slider_container = null;
        //         this.slider_container_transform = null;
        //     }
        // }
    }
}

customElements.define('quick-add', QuickAdd);